<mat-form-field 
    *ngIf="field" 
    appearance="outline" 
    [formGroup]="group" 
    [style.width]="field.matFormFieldWidth"
    (click)="openPicker()"
>

    <input 
        matInput 
        style="text-align:center;" 
        style="display: none;" 
        [readonly]="true"  
        [matDatepicker]="picker"
        [formControlName]="field.name"
        [min]="minDate" 
        [max]="maxDate"
    >

    <input  
        matInput 
        style="text-align:left" 
        [placeholder]="field.label"
        [value]="group.controls[field.name].value | dateFilter: field.dateConfig?.yearAndMonth ? 'MM/yyyy' : 'dd/MM/yyyy'"
        readonly
    >

    <mat-datepicker 
        #picker
        startView="multi-year" 
        [touchUi]="true" 
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, picker)"
    ></mat-datepicker>
    
</mat-form-field>


<!-- <mat-form-field  [formGroup]="group" appearance="outline">
  <mat-label>{{ field.label }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [formControlName]="field.name"
    [min]="minDate"
    [max]="maxDate"
    [readonly]="true"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker
    #picker
    startView="multi-year"
    [touchUi]="true"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, picker)"
  ></mat-datepicker>
</mat-form-field> -->


<ng-container *ngFor="let validation of field.validations;">
    <div style="margin-top:-1rem;margin-bottom:1rem;color:#f44336;font-size:75%" *ngIf="error(validation)">{{validation.message}}</div>
</ng-container>